import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import TemplateCard from "../components/TemplateCard";
import ProductCard from "../components/ProductCard";

import yellowtailPreview from "../images/yellowtail.png";
import purplesquidPreview from "../images/purplesquid.png";
import redsnapperPreview from "../images/redsnapper.png";

import scrilysPreview from "../images/scrilys.png";
import pichancePreview from "../images/pichance.png";
import gansPreview from "../images/gans.png";
import corgistickersPreview from "../images/corgistickers.png";
import iwanttobuildthisPreview from "../images/iwanttobuildthis.png";
import projectjobPreview from "../images/projectjob.png";

const LP_TEMPLATES = [
  {
    title: 'Yellow Tail',
    description: 'Trusting and friendly.',
    image: yellowtailPreview,
    detailsLink: '/yellowtail',
    demoLink: 'https://yellowtail.netlify.app'
  },
  {
    title: 'Purple Squid',
    description: 'Playful but powerful.',
    image: purplesquidPreview,
    detailsLink: '/purplesquid',
    demoLink: 'https://purplesquid.netlify.app'
  },
  {
    title: 'Red Snapper',
    description: 'Lively and adventurous.',
    image: redsnapperPreview,
    detailsLink: '/redsnapper',
    demoLink: 'https://redsnapper.netlify.app'
  }
]

const PRODUCTS = [
  {
    title: 'Scrilys',
    description: 'The writing app for authors',
    image: scrilysPreview,
    demoLink: 'https://scrilys.com'
  },
  {
    title: 'CorgiStickers',
    description: 'Get CorgiStickers!',
    image: corgistickersPreview,
    demoLink: 'https://corgistickers.netlify.app'
  },
  {
    title: 'Pic.Hance',
    description: 'Enhance your image 4X using AI',
    image: pichancePreview,
    demoLink: 'https://pichance.com'
  },
  {
    title: '9 GANS',
    description: 'AI generated art gallery',
    image: gansPreview,
    demoLink: 'https://9gans.com'
  },
  {
    title: 'Project Job',
    description: 'Find top developers through projects',
    image: projectjobPreview,
    demoLink: 'https://projectjob.dev'
  },
  {
    title: 'I Want To Build This',
    description: 'Build products users want',
    image: iwanttobuildthisPreview,
    demoLink: 'https://iwanttobuildthis.com'
  }       
]

function TemplatesPage() {
  return (
    <Layout>
      <SEO title="Showcase" />
      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16 min-h-screen">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Landing Page Templates</h1>
        <div className="flex flex-col md:flex-row md:flex-wrap items-center justify-evenly mt-10 lg:mt-16">
          {LP_TEMPLATES.map((item, index) => (
            <TemplateCard
              key={index}
              item={item}
            />
          ))}
        </div>
        <h1 className="text-3xl mt-16 leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Products</h1>
        <div className="flex flex-col md:flex-row md:flex-wrap justify-evenly mt-10 lg:mt-16">
          {PRODUCTS.map((item, index) => (
            <ProductCard
              key={index}
              item={item}
            />
          ))}
        </div>
      </section>
    </Layout>
  );
}

export default TemplatesPage;